import React from "react";
import { FlatList, View } from "react-native";
import { IconTokens, } from "@voltmoney/schema";
import CustomHeader from "../../customHeader/CustomHeader";
import { Accordion } from "../../accordion/Accordion";
import { faqDataList } from "./utils";
import { LENDER_ID } from "../constants";
import BoilerPlate from "../boilerPlate/BoilerPlate";
const FAQSection = ({ height, needHelpAction, triggerAction, goBackAction, showContactUs, tenure, lenderId }) => {
    const renderHeader = () => {
        return (React.createElement(View, { style: { marginTop: -16, marginHorizontal: -16 } },
            React.createElement(CustomHeader, { title: "FAQs", needHelpAction: needHelpAction, triggerAction: triggerAction, goBackAction: goBackAction, hideNeedHelp: !showContactUs })));
    };
    const renderIndividualFAQSection = (item, index) => {
        return (React.createElement(View, null,
            React.createElement(Accordion, { id: `${item.id}`, faqDownArrowIcon: true, title: `${item.title}`, description: lenderId === LENDER_ID.TATA.toLowerCase() ? item?.descriptionTata || item?.description : lenderId === LENDER_ID.DSP.toLowerCase() ? (item?.descriptionDSP || item?.description) : item.description, icon: IconTokens.DownArrow, onPress: () => { } })));
    };
    const renderBody = () => {
        return (React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(FlatList, { data: faqDataList(tenure), renderItem: ({ item, index }) => renderIndividualFAQSection(item, index), showsVerticalScrollIndicator: true })));
    };
    return (React.createElement(BoilerPlate, { height: height - 20, headerChild: renderHeader() }, renderBody()));
};
export default FAQSection;
